import { isDesktop, isMobile } from './MobileOrDesktop';

export default {
  methods: {
    isDesktop,
    isMobile,
    isMobiles: () => isMobile(),
  },
};
